import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PageLoading from "./components/PageLoading.vue";
import GoogleLogin from "vue-google-login";
import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  faPhone,
  faEnvelope,
  faAngleDoubleRight,
  faSearch,
  faRedoAlt,
  faSearchPlus,
  faDirections,
  faArrowLeft,
  faBan,
} from '@fortawesome/free-solid-svg-icons'
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'


library.add(faPhone, faEnvelope, faAngleDoubleRight, faSearch, faRedoAlt, faSearchPlus, faDirections, faArrowLeft, faBan);

Vue.config.productionTip = false;

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component("PageLoading", PageLoading);

Vue.component("GoogleLogin", GoogleLogin);


Vue.filter('formatPhone', function (phone, country) {

  if (country === "United States") {
    let cleaned = ("" + phone).replace(/\D/g, "");
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      let intlCode = match[1] ? "+1 " : "";
      return [intlCode, "", match[2], "-", match[3], "-", match[4]].join(
        ""
      );
    } else {
      return phone;
    }

  } else {
    return phone;
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");